export class CostReviewFireEnUsSystemAttributes {
  isSystemAttributeApplicableLessThanThreshold!: boolean;
  isSystemAttributeApplicable!: boolean;
  installType!: number;
  systemType!: number;
  additionalSystems!: number[];
}
